module.exports = __webpack_public_path__ + "static/media/UGPG.ae18f6ee.png";